<template>
  <v-dialog
    max-width="700"
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <v-card :loading="loading">
      <v-system-bar window>
        neuer Anlass
        <v-spacer />
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-system-bar>

      <v-container class="pt-4">
        <v-row>
          <v-col>
            <v-select
              dense
              single-line
              hide-details
              :items="tokens1"
              label="Abteilung"
              outlined
              v-model="token1"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              dense
              single-line
              hide-details
              :disabled="!tokens2[token1]"
              :items="tokens2[token1]"
              label="Beschreibung"
              outlined
              v-model="token2"
            ></v-select>
          </v-col>
          <v-col>
            <v-text-field
              dense
              single-line
              hide-details
              :disabled="!token2"
              label="Klassen / Gruppen"
              outlined
              v-model="token3"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-alert text type="error" v-if="!descriptionOK" dense>
              Bitte Abteilung, Beschreibung und Klassen / Gruppen auswählen
            </v-alert></v-col
          >
        </v-row>
        <v-row>
          <v-col class="text-display-2 dsdtext-center">{{ description }}</v-col>
        </v-row>
      </v-container>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">abbrechen</v-btn>
        <v-btn color="primary" text @click="save" :disabled="!descriptionOK"
          >erstellen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue";
import PersonItem from "common/components/PersonItem.vue";

export default defineComponent({
  components: { CurrencyValue, PersonItem },
  props: ["id"],
  data: () => ({
    item: { description: "", startDate: "", endDate: "" },
    loading: false,
    dialog: true,
    token1: "Abteilung",
    token2: "",
    token3: "",
    tokens1: ["GH", "MN", "WR"],
    tokens2: {
      GH: ["Blockwoche I", "Blockwoche II", "Maturreise"],
      MN: ["Mintwoche", "KD-Woche", "Maturreise"],
      WR: ["Sportwoche", "Kulturwoche", "Maturreise"],
    },
  }),
  computed: {
    description() {
      return this.item.description || this.token2 + " " + this.token3;
    },
    descriptionOK() {
      return this.token1 && this.token2 && this.token3;
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.$router.push({
          name: "InvoiceEvents2",
        });
      }
    },
  },

  methods: {
    save() {
      this.loading = true;
      this.apiPost({
        resource: "finance/invoiceevent",
        data: {
          description: this.description,
        },
      }).then((res) => {
        this.loading = false;
        this.$emit("updated");
        this.$router.push({
          name: "InvoiceEventEdit",
          params: { id: res.id },
        });
      });
    },
  },

  async created() {},
});
</script>
